const styles = ({ BREAKPOINTS }) => ({
  container: {
    display: 'flex',
    flexDirection: 'row'
  },
  input: {
    borderRadius: '4px 0 0 4px',
    borderRight: 'none',
    [`@media (max-width: ${BREAKPOINTS.XS})`]: {
      borderRadius: '4px',
      borderRight: '1px solid #ddd'
    }
  },
  button: {
    borderRadius: '0 4px 4px 0',
    whiteSpace: 'nowrap',
    [`@media (max-width: ${BREAKPOINTS.XS})`]: {
      display: 'none !important'
    }
  },
  buttonLabel: {
    display: 'inline-block',
    padding: '12px 15px',
    margin: '-12px -15px',
    cursor: 'pointer'
  }
})

export default styles
